import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader';
import aboutBg from '../../assets/AboutUs.png';
import { api, uploadUrl } from '../../utils/api';
import { CLIENT_CATEGORIES } from '../../constants/clientCategories';
import './Company.css';

export default function Clients() {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    api.getClients().then(setClients).catch(() => {});
  }, []);

  return (
    <div>
      <PageHeader
        title="주요 고객사"
        subtitle="다양한 분야의 기관과 함께 신뢰받는 감리 서비스를 제공합니다."
        bgImage={aboutBg}
      />
      <section className="page-section">
        <div className="container">
          {CLIENT_CATEGORIES.map((category) => {
            const categoryClients = clients.filter((c) => c.category === category);
            if (categoryClients.length === 0) return null;
            return (
              <div key={category} style={{ marginBottom: 56 }}>
                <div className="section-divider" />
                <h2 className="section-title" style={{ fontSize: '1.4rem', marginBottom: 24 }}>{category}</h2>
                <div className="clients-grid">
                  {categoryClients.map((client) => (
                    <div key={client.id} className="client-card">
                      <div className="client-logo-wrap">
                        {client.logo_filename ? (
                          <img src={uploadUrl(client.logo_filename)} alt={client.name} className="client-logo-img" />
                        ) : (
                          <span style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-dark)', textAlign: 'center' }}>
                            {client.name}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
